import { render, staticRenderFns } from "./card-row.vue?vue&type=template&id=79a1854b&scoped=true&"
import script from "./card-row.vue?vue&type=script&lang=js&"
export * from "./card-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1854b",
  null
  
)

export default component.exports